import FTLOptions from "./FTLOptions";
import { useEffect, useState } from "react";

export default function FollowTheLine(props) {
  var [time, setTime] = useState(1000);
  var [image, setImage] = useState("1");
  var [dirPath, setDirPath] = useState(
    "/VisuallyDirectedFineMotor/FollowTheLine/",
  );

  const [level, setLevel] = useState(props.levels[0].id);
  const [display, setDisplay] = useState(0);
  const [next, setNext] = useState(false);
  const [check, setCheck] = useState(true);
  const [levelLen, setLevelLen] = useState(5)
  const [count, setCount] = useState(1);
  
  /*
  function loadLevel(level, levelList) {
    for (let i = 0; i < levelList.Length; i++) {
      const img = new Image();
      const img2 = new Image();
      img.src =
        "/Visualization/Tangrams/" + level + "/" + levelList[i] + ".png";
      img2.src =
        "/Visualization/Tangrams/" + level + "/" + levelList[i] + "Answer.png";

      if (level <= 2) {
        const img3 = new Image();
        img3.src =
          "/Visualization/Tangrams/" + level + levelList[i] + "Pieces.png";
      }
    }
  }
  */

  // useEffect(() => {
  //   preLoadImages();
  // }, []);

  useEffect(() => {
    setDisplay(0);
    setCheck(true);
    setNext(false);
    
    // props.changePdf(dirPath + "/" + level + "/" + image + "HELP.pdf");
  }, [level, image]);

  function displayPicture(buttonName) {
    if (buttonName !== "check") {
      setDisplay(1);
      //console.log("Level pre",count)
      let n_count = (count+1) % (levelLen)
      setCount(n_count);
      //console.log("Level post",count, levelLen)
      //console.log(dirPath + "/" + level + "/" + (count+1) + ".png")
      setNext(true);
      setCheck(false);
    } else {
      setNext(false);
      setCheck(true);
      setDisplay(2);
    }
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <div className="activitySettingsButtonsContainer">
        <FTLOptions
          flashRate={setTime}
          flashBool={time}
          changeLevel={setLevel}
          changeLevelLen={setLevelLen}
          levelBool={level}
          hiddenLetter={setDirPath}
          letterBool={dirPath}
          hiddenLetterDisplay="none"
          levelDisplay="none"
          changeImage={setImage}
          imageBool={image}
          setCount={setCount}
          levels={props.levels}
        />
      </div>
      {props.open && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "90%",
          }}
        >
          {display === 1 && (
            <div
              style={{
                textAlign: "center",
                height:"100%"
              }}
            >
              <img
                style={{ width: "100%", height:"100%" }}
                src={dirPath + "/" + level + "/" + (count+1) + ".png"}
              />
            </div>
          )}
          {display === 2 && (
            <div style={{ textAlign: "center", height:"100%" }}>
              <img
                style={{ width: "100%", height:"100%" }}
                src={dirPath + "/" + level + "/" + (count+1) + "ANSWER" + ".png"}
              />
            </div>
          )}
        </div>
      )}
      <div className="activityActionButtonsContainer">
        <button
          className="activityActionButton"
          onClick={() => {
            if (props.open) {
              displayPicture("check");
            } else {
              props.openActivity(true);
            }
          }}
          disabled={check}
        >
          Check
        </button>
        <button
          className="activityActionButton"
          onClick={() => {
            if (props.open) {
              displayPicture("next");
            } else {
              props.openActivity(true);
            }
          }}
          disabled={next}
        >
          Next
        </button>
      </div>
    </div>
  );
}
